import { render, staticRenderFns } from "./LesiurpackageItem.vue?vue&type=template&id=5084e8ce&scoped=true"
import script from "./LesiurpackageItem.vue?vue&type=script&lang=js"
export * from "./LesiurpackageItem.vue?vue&type=script&lang=js"
import style0 from "./LesiurpackageItem.vue?vue&type=style&index=0&id=5084e8ce&prod&scoped=true&lang=css"
import style1 from "./LesiurpackageItem.vue?vue&type=style&index=1&id=5084e8ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5084e8ce",
  null
  
)

export default component.exports